<template>
  <div>
    <verify-phone-component :submitVerificationCode="oobaChallenge"
                            cancelLink="forcechallenge/cancel"
                            logoutLink="forcechallenge/logout"
                            resendLink="authentication/sendverificationcodechallenge" />
  </div>
</template>
<style>
</style>

<script>
  import redirectHandler from 'utils/redirect';
  import verifyphone from '../../SignIn/components/verify-phone';

  export default {
    name: 'VerificationChallenge',
    components: {
      'verify-phone-component': verifyphone
    },
    data: () => ({
      model: {
        prompt: null,
        answer: null,
        isMFAChallenge: true
      },
      disabled: false,
      oobaChallenge: {
        action: 'forcechallenge/index',
        isOOBARegistration: false
      }
    }),
    methods: {
      // No local validation; verify-phone handles v4 validation and server mapping
    }
  };
</script>